
import React from 'react';
import DivContainerBody from '../../../../../components/DivContainerBody';
import routes from '../../../../../Routes/routes';
import HeadTittle from '../../../../../components/HeadTittle';
import CommonCafeteriaApp from "../Functionality/CommonCafeteriaApp";
import CafeteriaFields from "./CafeteriaFields";
import CafeteriaMap from "./CafeteriaMap";
import CafeteriaAccess from "./CafeteriaAccess";
import UpdateCafeteriaApp from "../Functionality/UpdateCafeteriaApp";
import ButtonAction from "../../../../../components/buttons/ButtonAction";
import {EditIcon} from "../../../../../components/buttons/IconButtons";
import DividerWithText from "../../../../../components/DividerWithText";
/**
 * @Author: Karen Yunuen Pozos Arias
 * @JobTitle: Full Stack Developer - IBL
 * @Email: kpozos@ibl.mx
 */
const UpdateCafeteria = () => {
    const props = CommonCafeteriaApp();
    const {
        t,
        dispatch,
        getListStatus,
        item,
        setItem,
        handleChange,
        disabled,
        emptyFields,
        setEmptyFields,
        errorCode,
        errorName,
        dayArray,
        setDayArray,
        deviceList,
        setDeviceList,
        deviceSelectedList,
        setDeviceSelectedList,
        showOverlay,
        setShowOverlay,
        firstClickOnMap,
        setFirstClickOnMap,
        toRegisterDays,
        setIsValid,
        isValidCloseTime,
        setIsValidCloseTime
    } = props;


    const { handleUpdate } = UpdateCafeteriaApp({
        t,                       // i18n translation function
        item,                    // Current cafeteria model
        setItem,                 // Setter for cafeteria model
        setEmptyFields,          // Setter for indicating empty required fields
        dispatch,                // Redux dispatch function
        deviceSelectedList,      // List of selected devices for cafeteria
        setDeviceSelectedList,   // Setter for selected devices
        dayArray,                // Array of selected days
        setDayArray,             // Setter for selected days
        toRegisterDays,          // Function to convert days array to model
        setShowOverlay,          // Setter for overlay visibility
        setIsValid,              // Setter for capacity field validation
        setFirstClickOnMap,       // Setter for map interaction state
        isValidCloseTime,
        setIsValidCloseTime
    });

    return (<>
        <HeadTittle link={routes.foodie.list} name={'update'}>
            <ButtonAction
                id='btn_uc_update'
                name='update'
                Icon={EditIcon}
                className='btn-icon-edit'
                onClick={handleUpdate}
            />
        </HeadTittle>
        <DivContainerBody>
            <div className='row'>
                <div className={"col-12 input-padding-bottom input-padding-top"}>
                    <DividerWithText title={t('details')} />
                </div>

                <CafeteriaFields
                    item={item}
                    disabled={disabled}
                    emptyFields={emptyFields}
                    handleChange={handleChange}
                    errorCode={errorCode}
                    errorName={errorName}
                    statusList={getListStatus}
                />
            </div>
            <div className={"row"}>
                <div className={"col-12 input-padding-bottom input-padding-top"}>
                    <DividerWithText title={t('location')} />
                </div>
                <CafeteriaMap
                    item={item}
                    setItem={setItem}
                    disabled={disabled}
                    handleChange={handleChange}
                    showOverlay={showOverlay}
                    setShowOverlay={setShowOverlay}
                    firstClickOnMap={firstClickOnMap}
                />
            </div>
            <div className={"row"}>
                <CafeteriaAccess
                    item={item}
                    setItem={setItem}
                    emptyFields={emptyFields}
                    disabled={disabled}
                    handleChange={handleChange}
                    dayArray={dayArray}
                    setDayArray={setDayArray}
                    deviceList={deviceList}
                    setDeviceList={setDeviceList}
                    deviceSelectedList={deviceSelectedList}
                    setDeviceSelectedList={setDeviceSelectedList}
                    isValidCloseTime={isValidCloseTime}
                />
            </div>
        </DivContainerBody>
    </>)
}

export default UpdateCafeteria;
